import AuthService from './AuthService';


class ProfileService {
    constructor(authService) {
        this._authService = authService;
        this._locale = 'ru';
        this.avatarSaveUrl = '/profile/save-avatar';
        this.avatarDeleteUrl = '/profile/delete-avatar';
        this.basketUrl = '/profile/basket';
        this.basketAddToOftenUrl = '/profile/basket/add-to-often';
        this.basketDeleteOftenUrl = '/profile/basket/delete-often';
        this.basketDeleteUrl = '/order/delete';
        this.profileDataUrl = '/profile/get-general-data';
        this.profileUpdateUrl = '/profile/save-data';
        this.profileAddSeller = '/profile/add-seller';
        this.salesUrl = '/profile/sales';
        this.menuDataUrl = '/profile/get-menu';
    }
    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    addToOften(items) {
        return this._authService.getApiService().postResource(this.basketAddToOftenUrl, {orders: items}, this.getBaseHeaders());
    }

    changeRole(profileData) {
        return this._authService.getApiService().postResource(this.profileAddSeller, profileData, this.getBaseHeaders());
    }

    deleteOften(items) {
        return this._authService.getApiService().postResource(this.basketDeleteOftenUrl, {orders: items}, this.getBaseHeaders());
    }

    deleteOrder(id) {
        return this._authService.getApiService().postResource(this.basketDeleteUrl, {id}, this.getBaseHeaders());
    }

    getBasket(filters, page) {
        return this._authService.getApiService().postResource(this.basketUrl, {filters: filters, page: page}, this.getBaseHeaders());
    }

    getSales(filters, page) {
        return this._authService.getApiService().postResource(this.salesUrl, {filters: filters, page: page}, this.getBaseHeaders());
    }

    saveAvatar(imageData) {
        return this._authService.getApiService().postResource(this.avatarSaveUrl, imageData, this.getBaseHeaders());
    }

    deleteAvatar(imageData) {
        return this._authService.getApiService().postResource(this.avatarDeleteUrl, imageData, this.getBaseHeaders());
    }

    saveProfile(profileData) {
        return this._authService.getApiService().postResource(this.profileUpdateUrl, profileData, this.getBaseHeaders());
    }

    setLocale(locale) {
        this._locale = locale;
    }

    async generalData() {
        const response = await this.getGeneralData();

        return response.data;
    }

    async menuData() {
        const response = await this.getMenuData();

        return response.data;
    }

    async getGeneralData() {
        const apiService = this._authService.getApiService();

        return await apiService.postResource(this.profileDataUrl, {}, this.getBaseHeaders());
    }

    async getMenuData() {
        return await this._authService.getApiService().postResource(
            this.menuDataUrl,
            {},
            this.getBaseHeaders()
        );
    }


}

const profileService = new ProfileService(AuthService);

export default profileService;
